import reducerGenerator from '../utils/reducer-generator';
import cruReducerHelper from '../utils/cru-reducer-helper';
import requestStatuses from '../utils/request-statuses';
var create = reducerGenerator('create', requestStatuses.PENDING);
var createFail = reducerGenerator('create', requestStatuses.FAILED);
var createIdle = reducerGenerator('create', requestStatuses.IDLE);
function createSucceed(state, action, options) {
  return cruReducerHelper(state, action, options, {
    readStatus: requestStatuses.SUCCEEDED,
    createStatus: requestStatuses.SUCCEEDED
  });
}
export { create, createFail, createIdle, createSucceed };